module.exports = __webpack_public_path__ + "69b7f3866bf4d6e04a116fb88eda9021.svg";